import { useState } from "react";

function HColorInput() {
  const [hex, setHex] = useState("#000000");
  const isValidHex = /^#([0-9A-Fa-f]{6})$/.test(hex);

  return (
    <div className="flex items-center gap-2">
      <div
        className="w-8 h-8 rounded-full border"
        style={{
          backgroundColor: isValidHex ? hex : "transparent",
          borderColor: isValidHex ? hex : "gray",
        }}
        title={isValidHex ? hex : "Invalid hex"}
      />
      <input
        type="text"
        value={hex}
        onChange={e => setHex(e.target.value)}
        placeholder="#FFFFFF"
        maxLength={7}
        className="w-full p-2 rounded-md bg-gray-100"
      />
    </div>
  );
}

export default HColorInput;
